import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	newDefaultFiltersHeader: {
		id: 'spa-apps-sidebar-filters.global-scope.menu.system-filters.new-default-filters-header',
		defaultMessage: 'Default filters',
		description: 'Header of the default/system global filters navigation section',
	},
});
